import { ActiveSuspended, CenterOnOffPilot, CenterOrganType, DonorShieldStatus, VersionedFileEntityType, YesNo } from '@nkr/enums/index';

export interface IUpdateAdminDataRequest {
    alias: string,
    dashDomain: string,

    userName: string,
    password: string,

    billingModel: string,
    rmcrFeeMajor: number,
    rmcrFeeMinor: number,
    rmcrIsContractFeeWaived: YesNo,
    overrideDonorsProtectedKidney: YesNo,
    overrideDonorsProtectedLiver: YesNo,
    isInactivityFeeWaived: YesNo,

    monthlyFee: string,
    monthlyFeeNotes: string,
    dashFee: string,
    dashNotes: string,

    donorShieldFee: string,
    liverDonorShieldFee: string,

    invoicePoNumber: string,
    poAmount: string,
    invoicePoStartDate: string,
    invoicePoExpirationDate: string,
    invoiceDaysToRemit: string,

    nkrLiaisonId: number,
    executiveSponsorId: number,
    defaultMicrositeCoachUserId: number,

    isDeleted: YesNo,
    isTestCenter: YesNo,
    memberCenterType: CenterOrganType | null,
    isSuspended: YesNo,
    isMedicalBoard: YesNo,
    isAllIn: YesNo,
    isAdpPartner: YesNo,
    isDcnParticipant: YesNo,
    
    isMicrositeParticipant: YesNo,
    isMicrositeReferralCenter: YesNo,
    useMicrositeResponsibilityConfirmation: YesNo,

    isDppParticipant: YesNo,
    isStreamlinedBilling: YesNo,
    isFollowUpParticipant: YesNo,
    dashType: CenterOrganType | null,
    isInDonorShield: DonorShieldStatus,
    hasRecipientShield: YesNo,
    isGoldStar: YesNo,
    
    isInListingService: YesNo,
    isPrivate: YesNo,
    hasAgreedToFees: YesNo,
    paysUsViaAch: YesNo,
    
    isAcceptingReferrals: YesNo,
    nddReferrals: YesNo,

    excludeDataCompliance: YesNo,

    isRdnParticipant: YesNo,
    isAccParticipant: CenterOnOffPilot,
    hasCenterBilling: YesNo,
    ccbReviewDays: number,
    
    reduceEmails: YesNo,

    isUtilizing3gKidneyForLife: YesNo,
    doesAntibodyScreening: YesNo,
    getsFreeCheekSwabs: YesNo,
    isExpertSystemParticipant: YesNo,

    betaActivationStatus: CenterOnOffPilot,

    achRoutingNumber: string,
    achAccountNumber: string,

    packagingAchRoutingNumber: string,
    packagingAchAccountNumber: string,
    packagingAchApproved: number,

    files: {
        fileType: VersionedFileEntityType,
        fileVersion: number,
        fileDate: string,
        file: File
    }[],

    changeReasonsJson?: string
}